import { PillTheme } from "@redotech/redo-model/pill-theme";
import { memo } from "react";
import { Flex } from "../flex";
import { Text } from "../text";
import { TextInput } from "../text-input";
import { PillColorPicker } from "./tag-input-color-picker";
import { TagPillThemes } from "./tag-pill";

export const TagInputFields = memo(function TagInputFields({
  name,
  setName,
  pillTheme,
  setPillTheme,
  showNameError,
  disableNameEdit = false,
}: {
  name: string;
  setName(name: string): void;
  showNameError: boolean;
  pillTheme: PillTheme;
  setPillTheme(pillTheme: PillTheme): void;
  disableNameEdit?: boolean;
}) {
  return (
    <Flex dir="column" p="sm">
      <Flex dir="column">
        <Text fontSize="md" fontWeight="semibold">
          Tag name
        </Text>
        <TextInput disabled={disableNameEdit} onChange={setName} value={name} />
        {showNameError && (
          <Text
            fontSize="xs"
            pl="sm"
            textColor="error"
          >{`A tag with the name ${name} already exists`}</Text>
        )}
      </Flex>
      <Flex dir="column" pt="md">
        <Text fontSize="md" fontWeight="semibold">
          Tag color
        </Text>
        <PillColorPicker
          options={TagPillThemes}
          setValue={setPillTheme}
          value={pillTheme}
        />
      </Flex>
    </Flex>
  );
});
